module.exports = __webpack_public_path__ + "static/img/73.2e65a69.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/73.png
// module id = YX7C
// module chunks = 1